/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Application_Scope_BackstageInputs */

const en_enum_application_scope_backstage = /** @type {(inputs: Enum_Application_Scope_BackstageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage`)
};

const de_enum_application_scope_backstage = /** @type {(inputs: Enum_Application_Scope_BackstageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage`)
};

/**
* | output |
* | --- |
* | "Backstage" |
*
* @param {Enum_Application_Scope_BackstageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_application_scope_backstage = /** @type {((inputs?: Enum_Application_Scope_BackstageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Application_Scope_BackstageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_application_scope_backstage(inputs)
	return de_enum_application_scope_backstage(inputs)
});